import { useMemo, useState } from "react";
import { RefreshCw, ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "sonner";
import { loadOrders } from "../../data/adminData";
import { fmt, productById } from "../../data/store";
import { useCart } from "../../context/CartContext";

export default function AccOrders() {
  const orders = useMemo(() => loadOrders().slice(0, 10), []);
  const [open, setOpen] = useState(null);
  const { add, setDrawerOpen } = useCart();

  const repeat = (o) => {
    let added = 0;
    o.items.forEach((it) => {
      const id = Number((it.sku || "").replace("DEMO-", ""));
      const p = productById(id);
      if (p) { add(p, it.qty); added++; }
    });
    setDrawerOpen(added > 0);
    if (added) toast.success("Pasūtījums atkārtots", { description: `${added} preces pievienotas grozam.` });
    else toast.error("Preces vairs nav katalogā");
  };

  return (
    <div data-testid="account-orders">
      <h2 className="text-xl font-extrabold uppercase mb-4">Mani pasūtījumi ({orders.length})</h2>
      <div className="border border-[#E2E2E2]">
        {orders.map((o) => (
          <div key={o.nr} className="border-b border-[#F5F5F5]" data-testid={`acc-order-${o.nr}`}>
            <button onClick={() => setOpen(open === o.nr ? null : o.nr)} className="w-full flex items-center gap-3 px-4 py-3 text-sm text-left hover:bg-[#F5F5F5] transition-colors">
              <span className="font-bold w-32">{o.nr}</span>
              <span className="text-[#6B6B6B] hidden sm:block">{new Date(o.date).toLocaleDateString("lv-LV")}</span>
              <span className="text-xs font-bold">{o.status}</span>
              <span className="font-bold ml-auto">{fmt(o.total)}</span>
              {open === o.nr ? <ChevronUp size={15} /> : <ChevronDown size={15} />}
            </button>
            {open === o.nr && (
              <div className="px-4 pb-4">
                <div className="bg-[#F5F5F5] p-4 space-y-1.5">
                  {o.items.map((it, i) => (
                    <div key={i} className="flex justify-between text-sm">
                      <span>{it.name}</span>
                      <span className="font-semibold shrink-0 ml-3">{it.qty} × {fmt(it.price)}</span>
                    </div>
                  ))}
                  <button onClick={() => repeat(o)} data-testid={`repeat-order-${o.nr}`}
                    className="mt-3 bg-[#D0121A] hover:bg-[#A80D14] text-white text-xs font-bold px-4 py-2.5 flex items-center gap-1.5 transition-colors">
                    <RefreshCw size={13} /> Atkārtot pasūtījumu
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
